
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Resortnearbhandaraforfamilyouting() {



  const cardData =
  {
    keyword: ' Resorts Near Bhandara for Family Outing',
    heading:  'Woodland Escape: Resorts Near Bhandara for Family Outing ',
    headingDescription: 'Woodland Escape Resort, one of the best resorts near Bhandara for family outing, offers a perfect blend of comfort, fun, and natural beauty just a short drive from the city. Surrounded by lush greenery, open lawns, and serene forested areas, the resort provides an ideal setting for families to relax, bond, and enjoy quality time together. Guests can take part in a variety of activities such as nature walks, outdoor games, swimming, cycling, and adventure sports suitable for all ages, while children can explore and play freely in safe and spacious areas. With cozy cottages, delicious meals, and warm hospitality, Woodland Escape Resort near Bhandara ensures every family outing is filled with joy, relaxation, and unforgettable memories amidst nature’s charm.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "Resorts Near Bhandara for Family Outing",
"description": "Discover top resorts near Bhandara ideal for family outings, offering spacious accommodations, outdoor activities, and scenic surroundings perfect for a fun-filled day or weekend."
},
{
"name": "Bhandara Family Resort Stay",
"description": "Enjoy a comfortable family resort stay in Bhandara with amenities like kids’ play areas, nature walks, and recreational activities ensuring a memorable family experience."
},
{
"name": "Affordable Family Resorts Bhandara",
"description": "Experience budget-friendly family resorts in Bhandara without compromising on comfort, including meals, fun activities, and access to scenic spots for a relaxing stay."
},
{
"name": "Bhandara Weekend Family Resort",
"description": "Plan a weekend getaway at a Bhandara family resort with leisure facilities, outdoor fun, and nature exploration for all age groups, ideal for bonding and relaxation."
},
{
"name": "Bhandara Kids Friendly Resort",
"description": "Visit a kids-friendly resort in Bhandara with play areas, safe activities, and engaging programs for children, while adults can enjoy peace and recreation."
},
{
"name": "Bhandara Family Outing Resort",
"description": "Perfect for family outings, these resorts in Bhandara offer picnic spots, indoor and outdoor games, and comfortable stays surrounded by nature."
},
{
"name": "Bhandara Nature Resort for Families",
"description": "Immerse in nature at a family-friendly resort in Bhandara, featuring greenery, scenic views, outdoor activities, and eco-friendly experiences for all family members."
},
{
"name": "Bhandara Riverside Family Resort",
"description": "Relax by the riverside at Bhandara family resorts, enjoying calm water views, picnic setups, boating, and fun activities for a perfect day out."
},
{
"name": "Bhandara Hill Resort for Family",
"description": "Experience hilltop resorts in Bhandara for a family getaway with panoramic views, trekking options, and comfortable accommodations for a refreshing stay."
},
{
"name": "Bhandara Family Picnic Resort",
"description": "Combine a family picnic with resort stay in Bhandara, including open spaces, play areas, outdoor games, and delicious meals for a complete day of fun."
},
{
"name": "Bhandara Outdoor Family Resort",
"description": "Enjoy outdoor-focused family resorts in Bhandara, offering adventure activities, sports, nature trails, and spaces for group games and recreation."
},
{
"name": "Bhandara Group Family Resort",
"description": "Ideal for large family gatherings, Bhandara resorts provide group accommodations, shared activities, and facilities to ensure comfort and entertainment for everyone."
},
{
"name": "Bhandara Family Resort Booking",
"description": "Book your family resort in Bhandara in advance to secure a memorable outing with planned activities, meals, and a relaxing stay amidst scenic surroundings."
},
{
"name": "Bhandara One Day Family Resort",
"description": "Perfect for a quick getaway, enjoy a one-day family resort experience in Bhandara with outdoor fun, picnic facilities, and leisure activities."
},
{
"name": "Bhandara Luxury Family Resort",
"description": "Indulge in luxury family resorts near Bhandara, featuring premium accommodations, private spaces, exclusive activities, and high-end amenities for a lavish family outing."
}
],
"tableData": [
["- Resorts Near Bhandara for Family Outing", "- Bhandara Family Resort Stay"],
["- Affordable Family Resorts Bhandara", "- Bhandara Weekend Family Resort"],
["- Bhandara Kids Friendly Resort", "- Bhandara Family Outing Resort"],
["- Bhandara Nature Resort for Families", "- Bhandara Riverside Family Resort"],
["- Bhandara Hill Resort for Family", "- Bhandara Family Picnic Resort"],
["- Bhandara Outdoor Family Resort", "- Bhandara Group Family Resort"],
["- Bhandara Family Resort Booking", "- Bhandara One Day Family Resort"],
["- Bhandara Luxury Family Resort", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Ideal One Day Trip Near Bhandara",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect choice for a one‑day trip near Bhandara, offering a refreshing escape into nature without requiring an overnight stay. Set amidst lush forest surroundings, it invites you to enjoy a full day of scenic beauty, relaxation, and fun — all within easy reach from Bhandara."
  },
  {
    "WhyChooseheading": "Tranquil Forest Setting Near Bhandara",
    "WhyChoosedescription": "Located close to Bhandara, Woodland Escape Resort is surrounded by dense trees, clean air, and peaceful landscapes. The nature‑filled environment creates a calming backdrop for your day‑trip, providing a break from the city hustle."
  },
  {
    "WhyChooseheading": "Comfortable Day‑Use Facilities",
    "WhyChoosedescription": "Even for a day visit, comfort is key. Woodland Escape Resort offers well‑equipped day‑use zones — shady picnic areas, forest‑view sit‑outs, and rest spots. Whether you’re having lunch, relaxing between activities, or simply enjoying the forest ambience, you’ll be comfortable and relaxed."
  },
  {
    "WhyChooseheading": "Activities to Make Your Day Memorable",
    "WhyChoosedescription": "Spend your day at Woodland Escape Resort with a mix of fun and ease. Explore nature trails, stroll through the forest, cycle, try light adventure activities, or lounge by the pond. The resort offers options for all ages for a memorable one‑day outing."
  },
  {
    "WhyChooseheading": "Great for Family, Friends or Group Outings",
    "WhyChoosedescription": "Whether you’re planning a day out with family, friends, or a small group, Woodland Escape Resort provides the ideal backdrop. Its sprawling forest grounds, group‑friendly zones, and safe environment make it perfect for shared experiences and bonding."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "Your day gets better with tasty, freshly prepared meals and snacks from locally sourced ingredients. At Woodland Escape Resort, you’ll find options to keep everyone satisfied and energized as you enjoy the forest‑day experience."
  },
  {
    "WhyChooseheading": "Convenient Access from Bhandara",
    "WhyChoosedescription": "Located just a short scenic drive from Bhandara, Woodland Escape Resort is easily reachable for your day trip. Its proximity means you can maximize your time in nature and less time travelling."
  }
]

















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a family outing near Bhandara?",
    answer: "Woodland Escape Resort provides a safe, scenic, and activity-filled environment perfect for family getaways near Bhandara. Families can enjoy nature, outdoor games, and relaxing spaces together."
  },
  {
    question: "How far is Woodland Escape Resort from Bhandara city?",
    answer: "The resort is approximately 40–45 km from Bhandara, which takes around 1 to 1.5 hours by car. It’s convenient for both day trips and weekend family stays."
  },
  {
    question: "What family-friendly activities are available at the resort?",
    answer: "The resort offers a variety of activities including nature walks, cycling, open-lawn games, boating (if available), and kid-friendly play areas. Adults can relax while children are safely engaged."
  },
  {
    question: "Are accommodations suitable for families?",
    answer: "Yes! Woodland Escape Resort offers comfortable cottages and rooms that can accommodate families of different sizes. The lodging provides modern amenities while keeping guests close to nature."
  },
  {
    question: "Does the resort provide food for families?",
    answer: "Yes! The resort serves freshly prepared meals including vegetarian and non-vegetarian options. Picnic-style lunches and snacks are also available, making family stays convenient and enjoyable."
  },
  {
    question: "How can we book a family stay at Woodland Escape Resort near Bhandara?",
    answer: "You can book by calling or WhatsApp messaging our reservations team or visiting our website. Advance booking is recommended, especially on weekends and holidays, to ensure availability."
  }
];

const testimonials = [
  {
    name: "Mr. Amit & Family, Bhandara",
    text: "We had a wonderful family outing at Woodland Escape Resort! The kids loved the play areas, the adults enjoyed the peaceful surroundings, and the food was excellent. Truly the best family resort near Bhandara."
  },
  {
    name: "Miss. Priya & Family, Bhandara",
    text: "Woodland Escape Resort made our weekend getaway memorable! The accommodations were comfortable, the activities fun, and the environment serene. Perfect for a family outing near Bhandara."
  }
];

















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Resorts Near Bhandara for Family Outing",
  "image": "https://woodlandescape.com/assets/images/resorts-near-bhandara-family-outing.jpg",
  "description": "Enjoy a perfect family outing at Woodlandescape Resort — one of the best resorts near Bhandara for families. Experience kids-friendly activities, scenic nature, outdoor fun, and comfortable stays for a memorable weekend.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "365"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2799",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/resorts-near-bhandara-for-family-outing"
  }
};




  return (
    <div>
<Helmet>
  <title>Resorts Near Bhandara for Family Outing | Kids Friendly & Scenic Stay | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a fun-filled family outing at Woodlandescape Resort — one of the top resorts near Bhandara for families. Enjoy kids-friendly activities, outdoor fun, scenic nature, and comfortable weekend stays." 
  />
  <meta 
    name="keywords" 
    content="Resorts Near Bhandara for Family Outing, Bhandara Family Resort Stay, Affordable Family Resorts Bhandara, Bhandara Weekend Family Resort, Bhandara Kids Friendly Resort, Bhandara Family Outing Resort, Bhandara Nature Resort for Families, Bhandara Riverside Family Resort, Bhandara Hill Resort for Family, Bhandara Family Picnic Resort, Bhandara Outdoor Family Resort, Bhandara Group Family Resort, Bhandara Family Resort Booking, Bhandara One Day Family Resort, Bhandara Luxury Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/18.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Resortnearbhandaraforfamilyouting;